import { isNotDefined } from '@sgme/fp';

import type { BlotterOptionEntry } from '@/store/blotter/types/BlotterOptionEntry.ts';
import type { OptionSide } from '@/store/option/state.ts';
import type { CurrencyChoice } from '@/types/common.ts';

export function getTileSide(blotterEntry: BlotterOptionEntry): OptionSide {
  const value = blotterEntry.way?.trim()?.toLowerCase();
  switch (value) {
    case 'buy':
      return 'Buy';
    case 'sell':
      return 'Sell';
    default:
      return 'Buy';
  }
}

export function extractDay(date: string | undefined | null) {
  if (date == null) {
    return undefined;
  }
  const tIndex = date.indexOf('T');
  return tIndex === -1 ? date : date.slice(0, tIndex);
}

export function getCurrencyChoice(
  currency: string | null | undefined,
  currencyPair: string | null | undefined,
): CurrencyChoice | undefined {
  if (!currencyPair || !currency) {
    return undefined;
  }
  return currencyPair.startsWith(`${currency}/`) ? 1 : 2;
}

export function parseDecimal(value: string | null | undefined): number | undefined {
  if (isNotDefined(value)) {
    return undefined;
  }
  const parsed = Number.parseFloat(value);
  return Number.isNaN(parsed) ? undefined : parsed;
}
